<template>
    <!-- Objects types -->
    <el-form-item no-help :label="$t(label) + ' *'" prop="typeObjet">
        <el-cascader
                id="cascaderBien"
                v-model="post.typeObjet"
                :show-all-levels="false"
                :options="optionsObjectTypes"
                :props="{ expandTrigger: 'click', checkStrictly: true, emitPath: false }"
                :collapse-tags="true"
                filterable
                clearable
                :disabled="desactiverChamp"
                @change="$emit('typeChange')"
        ></el-cascader>
    </el-form-item>
</template>

<script>
import { mapState } from 'vuex'
import { getObjectTypes } from '../../../services/postsData'
import _groupBy from 'lodash/groupBy'
import _keyBy from 'lodash/keyBy'
import _omit from 'lodash/omit'
import _remove from 'lodash/remove'
import _each from 'lodash/each'
import _values from 'lodash/values'
import _filter from 'lodash/filter'

export default {
  name: 'PostFormObjectType',
  props: {
    post: Object,
    desactiverChamp: Boolean,
    typeSaisie: String,
    label: { type: String, default: 'posts.edit.propertyType' },
    minLevel: { type: Number, default: 2 },
    maxLevel: { type: Number, default: 99 },
    isProgramBailleur: { type: Boolean, default: false }
  },
  data: function () {
    return {
      type_objet: [],
      optionsObjectTypes: [],
      programBailleur: false
    }
  },
  beforeMount () {
    this.checkTypeObjet()
  },
  computed: {
    ...mapState('posts', ['filter']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    }
  },
  watch: {
    post: {
      handler: function (newVal) {
        this.checkTypeObjet()
      },
    }
  },
  methods: {
    async checkTypeObjet () {
      if (parseInt(this.post.typeObjet) >= 3000 && parseInt(this.post.typeObjet) < 4000 && this.isBailleurSocial && !this.filter.annonceParente) {
      this.type_objet = await getObjectTypes(null, null, 'PROMOTEUR')
    } else if (this.isBailleurSocial && !this.isProgramBailleur && !this.filter.annonceParente) {
      this.type_objet = await getObjectTypes(null, null, 'AGENCE')
    } else if (this.isBailleurSocial && this.isProgramBailleur && !this.filter.annonceParente) {
      this.type_objet = await getObjectTypes(null, null, 'PROMOTEUR')
    } else if (this.isBailleurSocial && this.filter.annonceParente) {
      this.type_objet = await getObjectTypes(this.filter.annonceParente, null, 'PROMOTEUR')
    } else {
      this.type_objet = await getObjectTypes(this.filter.annonceParente)
    }
    this.optionsObjectTypes = this.objectTypesTree(this.type_objet)
    },
    objectTypesTree (data) {
      _remove(data, function (currentObject) {
        return currentObject.niveau < this.minLevel || currentObject.niveau > this.maxLevel
      }.bind(this))

      _each(data, function (object) {
        object.value = object.code
        object.label = object.libelle
      })

      const groupedByParents = _groupBy(data, 'parentCode')
      const objectsByCode = _keyBy(data, 'code')

      _each(_omit(groupedByParents, undefined), function (children, parentCode) {
        if (objectsByCode[parentCode]) {
          objectsByCode[parentCode].children = children
        }
      })

      const results = _filter(objectsByCode, function (object) {
        return object.niveau === this.minLevel
      }.bind(this))
      return results
    }
  }
}
</script>
